import { useMutation } from 'react-query';
import { IServerErrorResponse } from '../../../../../../../../../types';
import { useStore } from '../../../../../../../../../store';
import { BASE_URL } from '../../../../../../../../../constants/endpoints';
import { httpService } from '../../../../../../../../../services/http.service';
import { IBillItem } from '../../../../../../../types';

interface IProps {
    billId: string,
}

export const cancelRequestVendorDetails = (onSuccess: (billItem: IBillItem) => void, onError: (data: IServerErrorResponse) => void) => {
  const { getPersonalAccount, user: { customerId } } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();

  return useMutation(
    async (props: IProps) => {
      const { data } = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${props.billId}/requestVendorDetails`, {});
      return data as IBillItem;
    },
    {
      onSuccess,
      onError,
    },
  );
};
